import CollectionDefinition from './CollectionDefinition';

export default class CollectionManager extends Backbone.Collection {
    get model() { return CollectionDefinition; }
}
